import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  Coefficient, CoefficientPrefill, CoefficientSaveRequest, CoefficientSummary, ConsumptionCheck, Mushak610,
  MushakFormSettings,
} from '../interfaces/indirectTax.interface';

const T = ENDPOINTS.INDIRECT_TAX;

/** B4-A: Mushak 4.3 coefficient declarations, the 6.10 statement and the editable form settings. */
export const MushakFormsService = {
  listCoefficients: async (institutionId: string): Promise<CoefficientSummary[]> =>
    (await axios.get(T.MUSHAK_COEFFICIENTS(institutionId))).data,
  getCoefficient: async (institutionId: string, id: string): Promise<Coefficient> =>
    (await axios.get(T.MUSHAK_COEFFICIENT(id, institutionId))).data,
  createCoefficient: async (institutionId: string, body: CoefficientSaveRequest): Promise<Coefficient> =>
    (await axios.post(T.MUSHAK_COEFFICIENTS(institutionId), body)).data,
  updateCoefficient: async (institutionId: string, id: string, body: CoefficientSaveRequest): Promise<Coefficient> =>
    (await axios.put(T.MUSHAK_COEFFICIENT(id, institutionId), body)).data,
  deleteCoefficient: async (institutionId: string, id: string): Promise<void> => {
    await axios.delete(T.MUSHAK_COEFFICIENT(id, institutionId));
  },
  submitCoefficient: async (institutionId: string, id: string, submissionDate?: string): Promise<Coefficient> =>
    (await axios.post(T.MUSHAK_COEFFICIENT_ACTION(id, 'submit', institutionId), { submissionDate: submissionDate ?? null })).data,
  returnCoefficientToDraft: async (institutionId: string, id: string): Promise<Coefficient> =>
    (await axios.post(T.MUSHAK_COEFFICIENT_ACTION(id, 'return-to-draft', institutionId))).data,
  acceptCoefficient: async (institutionId: string, id: string, vatOfficeReference: string, acceptedDate?: string): Promise<Coefficient> =>
    (await axios.post(T.MUSHAK_COEFFICIENT_ACTION(id, 'accept', institutionId), { vatOfficeReference, acceptedDate: acceptedDate ?? null })).data,
  downloadCoefficient: async (institutionId: string, id: string, kind: 'pdf' | 'xlsx'): Promise<Blob> =>
    (await axios.get(T.MUSHAK_COEFFICIENT_ACTION(id, kind, institutionId), { responseType: 'blob' })).data,
  prefill: async (institutionId: string, kind: 'style' | 'item', refId: string): Promise<CoefficientPrefill> =>
    (await axios.get(T.MUSHAK_COEFFICIENT_PREFILL(kind, refId, institutionId))).data,
  consumptionCheck: async (institutionId: string, buyerOrderId: string): Promise<ConsumptionCheck> =>
    (await axios.get(T.MUSHAK_CONSUMPTION_CHECK(institutionId, buyerOrderId))).data,
  get610: async (institutionId: string, from: string, to: string): Promise<Mushak610> =>
    (await axios.get(T.MUSHAK_610(institutionId, from, to))).data,
  download610: async (institutionId: string, from: string, to: string, format: 'pdf' | 'xlsx'): Promise<Blob> =>
    (await axios.get(T.MUSHAK_610(institutionId, from, to, format), { responseType: 'blob' })).data,
  getFormSettings: async (institutionId: string): Promise<MushakFormSettings> =>
    (await axios.get(T.MUSHAK_FORM_SETTINGS(institutionId))).data,
  saveFormSettings: async (institutionId: string, body: Omit<MushakFormSettings, 'institutionId' | 'loaded'>): Promise<MushakFormSettings> =>
    (await axios.put(T.MUSHAK_FORM_SETTINGS(institutionId), body)).data,
  loadFormDefaults: async (institutionId: string): Promise<MushakFormSettings> =>
    (await axios.post(T.MUSHAK_FORM_DEFAULTS(institutionId))).data,
};
